export const TARGET_ATTRIBUTE = 'controller';
export const ALIAS_KEY = `controller-name`;
export const TIMEOUT_KEY = `${TARGET_ATTRIBUTE}/timeout`;
export const CONTROLLER_KEY = `${TARGET_ATTRIBUTE}/controller`;
export const CONTROLLER_NAME_KEY = `${TARGET_ATTRIBUTE}/controller-name`;
export const ERROR_REPORTED = `${TARGET_ATTRIBUTE}/error-reported`;
export const EVENT_ATTACHED = `${TARGET_ATTRIBUTE}.attached`;
export const EVENT_DETACHED = `${TARGET_ATTRIBUTE}.detached`;
//# sourceMappingURL=Constants.js.map